import { useRef, useState } from 'react';
import './CitationSidebar.css';
import StyledButton from './StyledHtmlElements/Button';
import Box from './StyledHtmlElements/Box';

interface CitationSidebarProps {
  citation: { text: string; url: string } | null;
  onClose: () => void;
}

const CitationSidebar = ({ citation, onClose }: CitationSidebarProps) => {
  const [viewMode, setViewMode] = useState<'information' | 'source'>('information');
  const citationRef = useRef<HTMLDivElement | null>(null);
  const fileName = citation?.url.split('/').pop();

  return (
    <Box
      ref={citationRef}
      className="md:citation-sidebar flex max-md:absolute max-md:w-full max-md:right-0 max-md:top-0 h-full transition-all overflow-auto ">
      <div id="citation-content " className="grow">
        <div className="citation-header">
          <div className="view-toggle">
            <StyledButton
              onClick={() => setViewMode('information')}
              className={viewMode === 'information' ? 'active' : ''}>
              Information
            </StyledButton>
          </div>
          <StyledButton onClick={onClose} variant={'outline'} aria-label="Close">
            x
          </StyledButton>
        </div>

        <div className="citation-content">
          <div className="citation-information">
            <div className="citation-row">
              <strong>File:</strong> <span>{fileName || 'N/A'}</span>
            </div>
            <div className="citation-row">
              <strong>Content:</strong> <span>{citation?.text}</span>
            </div>
            <div className="citation-row">
              <strong>Location:</strong>
              <a href={citation?.url} target="_blank" rel="noopener noreferrer">
                {citation?.url}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default CitationSidebar;
